import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllTicketUser } from "../../../redux/actions";
import CardContainer from "../HistorServicios/CardContainer";
import { FaHistory, FaSearch, FaFilter, FaUserTie } from 'react-icons/fa';
import styles from '../../../view/Tickets/GenerarTicket.module.css';

const HistorialTicket = () => {
    const dispatch = useDispatch();
    const allticketced = useSelector((state) => state.alltickuser);
    // console.log("TICKET::",allticketced)
    const [searchTerm, setSearchTerm] = useState("");
    const [estadoFilter, setEstadoFilter] = useState("ALL");
    const [tecnicoFilter, setTecnicoFilter] = useState("ALL");

    const tecnicos = Array.from(
        new Set(
            allticketced
                ?.flatMap(item => item.tickets || [])
                .filter(t => t.Usuario && t.EstadoId === 2)
                .map(t => t.Usuario.nombre.trim())
        )
    ).sort();

    useEffect(() => {
        dispatch(getAllTicketUser());
    }, [dispatch]);

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}>
                    <FaHistory style={{ marginRight: '15px' }} />
                    Historial Global de Servicios
                </h2>
                <p className={styles.subtitle}>Supervisión y consulta de todos los tickets gestionados por el sistema.</p>
            </header>

            {/* 🛠 BARRA DE HERRAMIENTAS / FILTROS */}
            <div style={{
                background: 'white',
                padding: '24px',
                borderRadius: '24px',
                border: '1px solid rgba(0,0,0,0.05)',
                marginBottom: '32px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }}>
                <div style={{ position: 'relative', width: '100%' }}>
                    <FaSearch style={{ position: 'absolute', left: '16px', top: '16px', color: '#94a3b8' }} />
                    <input
                        type="text"
                        placeholder="Buscar por ticket o usuario..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: "100%",
                            padding: '12px 16px 12px 48px',
                            borderRadius: '12px',
                            border: '2px solid #f1f5f9',
                            background: '#f8fafc',
                            fontSize: '0.95rem',
                            outline: 'none',
                            transition: 'all 0.2s'
                        }}
                    />
                </div>

                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1', minWidth: '200px', position: 'relative' }}>
                        <FaFilter style={{ position: 'absolute', left: '12px', top: '14px', color: '#94a3b8', fontSize: '0.9rem' }} />
                        <select
                            value={estadoFilter}
                            onChange={(e) => setEstadoFilter(e.target.value)}
                            style={{
                                width: "100%",
                                padding: '10px 12px 10px 36px',
                                borderRadius: '10px',
                                border: '1px solid #e2e8f0',
                                background: 'white',
                                color: '#475569',
                                fontWeight: '600',
                                outline: 'none'
                            }}
                        >
                            <option value="ALL">Todos los estados</option>
                            <option value="1">🟢 Creado</option>
                            <option value="2">🔵 En proceso</option>
                            <option value="3">🟡 Pendiente</option>
                            <option value="4">✅ Resuelto</option>
                            <option value="5">🔒 Cerrado</option>
                            <option value="6">❌ Cancelado</option>
                        </select>
                    </div>

                    <div style={{ flex: '1', minWidth: '200px', position: 'relative' }}>
                        <FaUserTie style={{ position: 'absolute', left: '12px', top: '14px', color: '#94a3b8', fontSize: '0.9rem' }} />
                        <select
                            value={tecnicoFilter}
                            onChange={(e) => setTecnicoFilter(e.target.value)}
                            style={{
                                width: "100%",
                                padding: '10px 12px 10px 36px',
                                borderRadius: '10px',
                                border: '1px solid #e2e8f0',
                                background: 'white',
                                color: '#475569',
                                fontWeight: '600',
                                outline: 'none'
                            }}
                        >
                            <option value="ALL">Todos los técnicos</option>
                            {tecnicos.map((tec, index) => (
                                <option key={index} value={tec}>
                                    {tec}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <CardContainer
                allticketced={allticketced}
                searchTerm={searchTerm}
                estadoFilter={estadoFilter}
                tecnicoFilter={tecnicoFilter}
            />
        </div>
    );
};

export default HistorialTicket;
